import { useEffect } from 'react'

const FullRedirect = ({ to }) => {
    useEffect(() => {
        location.href = `${location.origin}${to}`
    }, [])

    return null
}

export default FullRedirect
